import { ExistingVariant, VariationGroup } from 'editor/src/store/variants/types';

function getDesignOptionKey({ designOptions }: ExistingVariant | VariationGroup) {
  return designOptions?.[0].optionKey;
}

export default getDesignOptionKey;
